import React, { useState, useContext } from 'react';
import Tabs from '../components/Stats/Tabs';
import Overview from '../components/Stats/Overview';
import Players from '../components/Stats/Players';
import Teams from '../components/Stats/Teams';
import Standings from '../components/Stats/Standings';
import {useTeamsStats} from "../hooks/teamStats";
import {usePlayersStats} from "../hooks/playerStats";

function StatsPage() {
  const [contentToDisplay, setContentToDisplay] = useState(window.pageData.data['content']);
  const [playersStats, playersStatsLoading, playersStatsError] = usePlayersStats(currentSeason);
  return (
    <div className="row">
      <div className="col-12 col-xl-12">
        <div className="row px-3 px-md-4 mb-3">
          <div className="col-12 col-md-7 d-flex align-items-center mb-4 mb-md-0 justify-content-center justify-content-md-start">
            <h1 className="heading-h2">Statistik</h1>
          </div>
        </div>
        <Tabs switchContent={setContentToDisplay} />
        <div className="row">
          <div className="col-12">
            <Overview show={contentToDisplay === 'overview'} />
            <Players show={contentToDisplay === 'players'} />
            <Teams show={contentToDisplay === 'teams'} />
            <Standings show={contentToDisplay === 'tables'} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default StatsPage;
